import React from 'react';
import PropTypes from 'prop-types';
import { Box, useTheme } from '@chakra-ui/react';

export default function FormContainer({ children }) {
  const theme = useTheme();
  return (
    <Box maxW={theme.breakpoints.md} p={0}>
      {children}
    </Box>
  );
}

FormContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
